import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import api from "PFCore/api";
import { Activity, EngagementBlueprint, Id, PaginatedCollection, QueryParams } from "PFTypes";

import { ActivityOperation } from "../bulk_operations";

export type EngagementBlueprintFormData = Omit<EngagementBlueprint, "id" | "activitiesCount" | "profile">;

export enum AdminEngagementBlueprintActivitiesAction {
  Create = "create",
  Update = "update",
  Destroy = "destroy"
}

export type BulkActivityResult = {
  id: number | null;
  itemIdentifier: RoleFormKey;
  action: AdminEngagementBlueprintActivitiesAction;
  errors: Record<string, string[]> & { metadata?: Record<string, string[]>[] };
};

export type AdminEngagementBlueprintActivitiesParams = Pick<QueryParams, "page" | "perPage"> & {
  subtemplateKey?: string;
};

export type AdminEngagementBlueprintActivitiesResponse = PaginatedCollection<Activity[]>;

export const fetchAdminEngagementBlueprints = ({
  page = 1,
  perPage = 25
}: QueryParams): Promise<PaginatedCollection<EngagementBlueprint[]>> =>
  api({
    url: "admin/engagement_blueprints",
    params: { page, perPage }
  });

export const fetchEngagementBlueprint = (id: Id): Promise<EngagementBlueprint> =>
  api({
    url: `admin/engagement_blueprints/${id}`
  });

export const createEngagementBlueprint = (
  formData: EngagementBlueprintFormData
): Promise<EngagementBlueprint> =>
  api({
    method: "POST",
    url: "admin/engagement_blueprints",
    data: formData
  });

export const updateEngagementBlueprint = (
  id: Id,
  formData: EngagementBlueprintFormData
): Promise<EngagementBlueprint> =>
  api({
    method: "PUT",
    url: `admin/engagement_blueprints/${id}`,
    data: formData
  });

export const deleteEngagementBlueprint = (id: Id): Promise<void> =>
  api({
    method: "DELETE",
    url: `admin/engagement_blueprints/${id}`
  });

export const bulkAdminBlueprintActivitiesOperations = (
  id: Id,
  bulkOperations: ActivityOperation[]
): Promise<BulkActivityResult[]> =>
  api({
    method: "POST",
    url: `admin/engagement_blueprints/${id}/activities/bulk`,
    data: { items: bulkOperations }
  });

export const fetchAdminEngagementBlueprintActivities = (
  engagementBlueprintId: Id,
  { page = 1, perPage = 25, subtemplateKey }: AdminEngagementBlueprintActivitiesParams
): Promise<AdminEngagementBlueprintActivitiesResponse> =>
  api({
    url: `admin/engagement_blueprints/${engagementBlueprintId}/activities`,
    params: { page, perPage, subtemplateKey }
  });
